export enum TicketType {
	NotSet = 0,
	Sale = 1,
	Seosanal = 2,
	Comp = 3,
    Group = 4,
    Sponsor = 5,
    Bundle = 6
}



// WEBPACK FOOTER //
// ./src/app/models/ticket-type.enum.ts